<template>
    <div class="nationalDistributionMenu">
        <el-menu
            :default-active="'0-1'"
            :default-openeds="['0', '1', '2', '3']"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            background-color="#212943"
            text-color="#fff"
            active-text-color="#fff">
            <el-submenu v-for="(menu) in menuList" :index="menu.index" :key="menu.href">
                <template slot="title">
                    <img :src="menu.img" class="icon-img" alt="icon">
                    <span>{{menu.name}}</span>
                </template>
                <el-menu-item-group>
                    <el-menu-item :default-active="navselected" v-for="nav in menu.navlist" @click="changeNav(nav)" :class="{'isActive': nav.index === navselected}" :key="nav.href">{{nav.name}}</el-menu-item>
                </el-menu-item-group>
            </el-submenu>
        </el-menu>
        <div class="logoMenu" @click="gotoIndex">
            <img :src="logoMenu" alt="" class="img">
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'nationalDistributionMenu',
    data() {
        return {
            active: '1',
            navselected: '0-1',
            logoMenu: require('@/common/images/nationalDistributionMenu/logo_menu.png'),
            menuList: [
                {
                    index: '0',
                    name: '分销管理',
                    img: require('@/common/images/nationalDistributionMenu/icon_home_default@2x.png'),
                    navlist: [
                        {name: '活动管理', href: 'NDActivity', index: '0-1', path: '/tools/nationalDistribution/activityList'},
                        {name: '订单管理', href: 'NDOrder', index: '0-2', path: '/tools/nationalDistribution/orderList'},
                        {name: '用户管理', href: 'NDUser', index: '0-3', path: '/tools/nationalDistribution/userList'}
                    ]
                },
                {
                    index: '1',
                    name: '数据分析',
                    img: require('@/common/images/nationalDistributionMenu/icon_marketing_default@2x.png'),
                    navlist: [
                        // {name: '运营数据', href: 'NDMarketing', index: '1-1', path: '/tools/nationalDistribution/marketingList'},
                        {name: '数据分析', href: 'NDDataAnalysis', index: '1-2', path: '/tools/nationalDistribution/dataAnalysis'}
                    ]
                },
                {
                    index: '2',
                    name: '资金管理',
                    img: require('@/common/images/nationalDistributionMenu/icon_data_default@2x.png'),
                    navlist: [
                        {name: '活动收入', href: 'NDActivityIncomeList', index: '2-1', path: '/tools/nationalDistribution/incomeList'},
                        {name: '提现列表', href: 'NDWithdrawalList', index: '2-2', path: '/tools/nationalDistribution/withdrawalList'}
                        // {name: '用户提现', href: 'NDWithdrawalUserList', index: '2-2', path: '/tools/nationalDistribution/withdrawalUserList'}
                    ]
                },
                {
                    index: '3',
                    name: '分销设置',
                    img: require('@/common/images/nationalDistributionMenu/icon_setting_default@2x.png'),
                    navlist: [
                        {name: '分销主页', href: 'NDPdIndex', index: '3-1', path: '/tools/nationalDistribution/pdIndex'}
                    ]
                }
            ]
        }
    },
    mounted() {
        this.menueChoice(this.menuList)
    },
    methods: {
        menueChoice(arr) {
            let path = window.location.pathname
            arr.forEach((obj1, index1) => {
                obj1.navlist.forEach((obj2, index2) => {
                    if (obj2.path === path) {
                        // this.active = obj1.index
                        this.navselected = obj2.index
                    }
                })
            })
        },
        gotoIndex() {
            this.$router.push({name: 'Index'})
        },
        selectMenu(params) {
        },
        handleOpen(key, keyPath) {
        },
        handleClose(key, keyPath) {
        },
        changeNav(nav) {
            this.active = nav.index.split('-')[0]
            this.navselected = nav.index
            this.$router.push({name: nav.href})
        },
        ...mapActions([
            'setPermission',
            'setPermissionBtn'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'permission'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.nationalDistributionMenu {
    overflow: visible;
    background: #1C2237;
    .isActive {
        background: #409EFF !important;
    }
    .el-menu .icon-img {
        display: inline-block;
        margin-right: 10px;
        width: 16px;
    }
    .el-menu-item-group{
        .el-menu-item-group__title{
            display: none;
        }
    }
    .el-collapse-item__header {
        font-size: 14px;
        color: #303133;
        padding-left: 20px;
        border: none;
        img {
            width: 16px;
            height: 16px;
            margin-right: 10px;
        }
        .el-icon-arrow-right {
            display: none;
        }
    }
    .arrows {
        .el-icon-arrow-right {
            display: block;
            margin-left: 50px;
        }
    }
    .special {
        .el-collapse-item__header {
            .selected {
                display: none;
            }
        }
    }
    .el-collapse-item__header:hover {
        color: #409EFF;
        background: #E6F1FC;
        .selected {
            display: block !important;
        }
        .default {
            display: none;
        }
    }
    .el-collapse-item__wrap {
        border: none;
    }
    .item {
        .el-collapse-item__header {
            color: #409EFF;
            background: #E6F1FC;
        }
    }
    .el-collapse-item__content {
        padding: 0;
        .itemContent1 {
            display: flex;
            flex-wrap: wrap;
            padding-left: 36px;
            div {
                width: 70px;
                line-height: 32px;
                color: #606266;
                font-size: 12px;
                box-sizing: border-box;
                padding-left: 5px;
                // text-align: center;
                margin-top: 2px;
                margin-left: 1px;
                cursor: pointer;
            }
            .active {
                color: #409EFF;
                background: #E6F1FC;
            }
            .insideBtn {
                color: #409EFF;
            }
            div:hover {
                color: #409EFF;
                background: #E6F1FC;
            }
        }
        .itemContent2 {
            div {
                line-height: 32px;
                text-indent: 45px;
                margin-top: 2px;
                font-size: 12px;
                color: #606266;
                cursor: pointer;
            }
            .active {
                color: #409EFF;
                background: #E6F1FC;
            }
            .insideBtn {
                color: #409EFF;
            }
            div:hover {
                color: #409EFF;
                background: #E6F1FC;
            }
        }
    }
    .division {
        height: 10px;
        background: #F5F7FA;
    }
    .is-disabled {
        .el-collapse-item__header {
            color: #303133;
            cursor: pointer;
        }
        .el-collapse-item__header:hover {
            color: #409EFF;
        }
    }
    .logoMenu{
        position: absolute;
        bottom: 12px;
        left: 0;
        right: 0;
        text-align: center;
        .img{
            width: 96px;
            height: 18px;
        }
    }
}
</style>
